import { Inject, Injectable } from '@angular/core';
import { OldDataService } from 'src/app/core/services/old-data.service';
// import { AppConfig, APP_CONFIG } from 'app/app-config.module';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';

@Injectable({
	providedIn: 'root',
})
export class ContractsService {
	constructor(
		private dataService: OldDataService,
		private http: HttpClient,
		private utils: UtilsService
	) {}

	getContract(userid: number, contractid: number) {
		const payload = {
			userid: userid,
			contractid: contractid,
		};
		const url = `${environment.api}contract/get_contract_client`;
		return this.http.post(url, payload );
	}

	getContractNew(contract_id: number) {
		const url = `${environment.api}contract/${contract_id}/get_contract`;
		return this.http.get(url);
	}

	uploadDocument(formData: any): Observable<any> {
		const url = `${environment.api}contract/upload_document`;
		return this.http.post(url, formData);
	}

	getDocumentsByContract(contract_id) {
		const url = `${environment.api}contract/${contract_id}/get_documents_contracts`;
		return this.http.get(url);
	}

	deleteFile(payload) {
		const url = `${environment.api}contract/delete_file_contract`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	getAllContracts() {
		const url = `${environment.api}contract/get_all_contracts`;
		return this.http.get(url);
	}

	updateRelationContractCampaign(payload){
		const url = `${environment.api}contract/update_relation_cont_cam`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	addContractToCampaign(payload){
		const url = `${environment.api}contract/add_contract_campaigs`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	addSortDefaultleads(payload){
		const url = `${environment.api}contract/add_sort_default_lead`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	getContractsCampaignClient(user_id){
		const url = `${environment.api}contract/${user_id}/get_contracts_campaign_client`;
		return this.http.get(url, {});
	}

	deactivateContract(contract_id){
		const url = `${environment.api}contract/${contract_id}/deactivate_contract`;
		return this.http.get(url, {});
	}

	deactivateCampaignContract(contract_campaign_relation_id){
		const url = `${environment.api}contract/${contract_campaign_relation_id}/deactive_campaign_contracts`;
		return this.http.get(url, {});
	}

	getLeadsWeekSorted(contract_id){
		const url = `${environment.api}contract/${contract_id}/get_leads_week_sorted`;
		return this.http.get(url, {});
	}

	getCampaignContract(contract_id){
		const url = `${environment.api}contract/${contract_id}/get_campaign_contract`;
		return this.http.get(url, {});
	}

	createContract(payload) {
		const url = `${environment.api}contract/create_contract`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	getUserContractsForCampaignWizard(user_id: number) {
		const url = `${environment.api}contract/${user_id}/get_user_contracts_for_campaign_wizard`;
		return this.http.get(url);
	}

	uploadContractDocument(formData){
		const url = `${environment.api}contract/upload_document_new`;
		return this.http.post(url, formData);
	}

	getDocumentsByContractNew(contract_id: number) {
		const url = `${environment.api}contract/${contract_id}/documents`;
		return this.http.get(url);
	}

 	downloadContractDocument(payload) {
		const url = `${environment.api}contract/download_document`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);

	}

	deleteFileNew(payload) {
		const url = `${environment.api}contract/delete_file_contract_new`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	linkContractToCampaign(payload) {
		const url = `${environment.api}contract/link_contract_to_campaign`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	updateContract(contract: any, types) {
		contract.types = types;
		var formData: any = this.utils.jsonToFormData(contract);
		const url = `${environment.api}contract/update_contract`;
		return this.http.post(url, formData);
	}

}
